import { get } from "../methods";
const defaultConfig = () => ({
  companyIdentifier: ""
});
function getIndustryCompany_default(config = defaultConfig()) {
  const { companyIdentifier, payload } = config;
  return get({
    url: `api/industry/company/${companyIdentifier}`,
    payload
  });
}
export {
  getIndustryCompany_default as default
};
